import type { HTMLAttributes, ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./Card.module.css";

/** Contenedor presentacional (sin interacción). */
export function Card({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={[styles.card, className ?? ""].filter(Boolean).join(" ")} {...rest} />;
}

/** Card NAVEGABLE: affordance real — elevación/hundido al presionar y chevron ›.
 *  Úsala para superficies que llevan a otra pantalla (no "click en la card muda"). */
export function CardLink({
  to,
  className,
  children,
  chevron = true,
}: {
  to: string;
  className?: string | undefined;
  children: ReactNode;
  chevron?: boolean;
}) {
  return (
    <Link to={to} className={[styles.card, styles.interactive, className ?? ""].filter(Boolean).join(" ")}>
      <div className={styles.interactiveBody}>{children}</div>
      {chevron ? (
        <span className={styles.chevron} aria-hidden="true">
          ›
        </span>
      ) : null}
    </Link>
  );
}
